export function roundLbsOffset(lbsOffset: number) {
    // Round to nearest million or thousands depending on amount
    const roundedLbsOffset =
        lbsOffset < 1000000 ? lbsOffset / 1000 : lbsOffset / 1000000;
    // Determine amount suffix
    const suffix = lbsOffset < 1000000 ? "k" : "M";
    return {roundedLbsOffset, suffix}
}